import { FC } from 'react';

import { FormWrapper } from '../../../Common/FormWrapper';

import { useNavigate } from 'react-router-dom';

interface IFinalStepProps {
  title: string;
  buttonText: string;
  customerId: string;
}

export const FInalStep: FC<IFinalStepProps> = ({ title, buttonText, customerId   }) => {
  const navigate = useNavigate();

  const handleSubmit = async () => {
    navigate(`/${customerId}/overview`);
    setTimeout(() => {
      window.location.reload();
    }, 0);
  };

  return (
    <FormWrapper
      title={title}
      isLastStep
      buttonText={buttonText}
      currentStep={7}
      onSubmit={handleSubmit}
    >
      {null}
    </FormWrapper>
  );
};
